import {
  SET_PAYERS_FILTERS,
  RESET_PAYERS_FILTERS,
  SET_PAYERS_GRID_SORT_CRITERIA,
} from './actionTypes';

export const setPayersFilters = filters => ({
  type: SET_PAYERS_FILTERS,
  filters,
});

export const cleanPayersFilters = () => ({
  type: RESET_PAYERS_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_PAYERS_GRID_SORT_CRITERIA,
  sortCriteria,
});
